import {Component, Input, OnInit} from '@angular/core';
import {NEWSLETTER_ZONE} from '../../models/newsletter';
import {NewslettersService} from '../../services/newsletters.service';
import {USER_ROLE} from '../../models/user';

@Component({
    selector: 'pv-shared-alert',
    templateUrl: './shared-alert.component.html',
    styleUrls: ['./shared-alert.component.scss'],
    standalone: false
})
export class SharedAlertComponent implements OnInit {
  public alerts = [];
  @Input() zone: NEWSLETTER_ZONE;

  constructor(private newslettersService: NewslettersService) { }

  ngOnInit(): void {
    this.newslettersService.getAlerts(this.zone).then(res => {
      this.alerts = res;
    })
  }

}
